import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect();
        }
    }, [isLoading, isAuthenticated, loginWithRedirect]);

    if (isLoading) {
        return <div ><span className="m-6">Loading...</span></div>; // Optional: Add a loading spinner or message
    }

    if (!isAuthenticated) {
        return <div ><span className="m-6">Redirecting...</span></div>;
    }

    return children;
};

export default ProtectedRoute;
